import { Component, forwardRef, HostBinding, Inject, Input, OnDestroy, OnInit } from '@angular/core'
import { BaseHrefService } from '../../../../../../framework/base-href/base-href.service'
import { DomSanitizer } from '@angular/platform-browser'
import { ConfiguratorSteeringWheelpickerComponent } from '../configurator-steeringwheelpicker/configurator-steeringwheel-picker.component'
import { getSteeringWheelImage } from '../configurator-steeringwheelpicker/configurator-steeringwheel-picker'

@Component({
    selector: 'mg-configurator-steeringwheel-picker-option',
    templateUrl: './configurator-steeringwheel-picker-option.component.html',
    styleUrls: ['./configurator-steeringwheel-picker-option.component.scss'],
})
export class ConfiguratorSteeringWheelpickerOptionComponent implements OnInit, OnDestroy {
    @Input()
    amount: number = 0

    @HostBinding('style.background-image')
    backgroundImage: string

    @HostBinding('class.showInCircles')
    @Input()
    showInCircles: boolean = true

    /**
     * Reference to parent component is injected to allow configurator-model and name registration
     * @param _parent
     */
    constructor(
        @Inject(forwardRef(() => ConfiguratorSteeringWheelpickerComponent))
        public _parent: ConfiguratorSteeringWheelpickerComponent,
        private baseHrefService: BaseHrefService,
        private domSanitizer: DomSanitizer
    ) {}

    private _description = ''

    get description(): string {
        return this._description
    }

    @Input()
    set description(value: string) {
        this._description = value
        const steeringWheelImage = getSteeringWheelImage(value)
        let backgroundImage

        if (steeringWheelImage) {
            backgroundImage = this.baseHrefService.createUrl(steeringWheelImage)
            backgroundImage = this.domSanitizer.bypassSecurityTrustStyle(`url(${backgroundImage})`)
        }
        this.backgroundImage = backgroundImage
    }

    @HostBinding('class.isChecked')
    get isChecked(): boolean {
        return (
            (this.value && this.value === this._parent.value) ||
            this.value.id === ((this._parent.value && this._parent.value.id) || -999)
        )
    }

    /**
     * Value can be set manually or uses amount by default
     */
    private _value: any

    @Input()
    get value() {
        return this._value || this.amount
    }

    set value(value) {
        this._value = value
    }

    ngOnInit(): void {
        if (this._parent) {
            this._parent.registerChild(this)
        }
    }

    ngOnDestroy(): void {
        if (this._parent) {
            this._parent.removeChild(this)
        }
    }
}
